if (!customElements.get('ugc-videos')) {
  customElements.define(
    'ugc-videos',
    class UgcVideos extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));

        this.row = this.querySelector('.ugc-videos__row');
        this.prev = this.querySelector('.ugc-videos__nav--prev');
        this.next = this.querySelector('.ugc-videos__nav--next');

        if (this.row && this.prev && this.next) {
          this.prev.addEventListener('click', () => this.scrollByCards(-1));
          this.next.addEventListener('click', () => this.scrollByCards(1));
          this.row.addEventListener('scroll', () => this.updateNav(), {
            passive: true,
          });

          this.updateNav();
          // Recalculate once videos/images settle and on resize.
          window.addEventListener('resize', () => this.updateNav());
          if ('ResizeObserver' in window) {
            new ResizeObserver(() => this.updateNav()).observe(this.row);
          }
        }
      }

      scrollByCards(direction) {
        if (!this.row) return;
        const card = this.row.querySelector('.ugc-videos__card');
        const step = card ? card.offsetWidth + 16 : this.row.clientWidth * 0.8;
        this.row.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      updateNav() {
        if (!this.row || !this.prev || !this.next) return;
        const maxScroll = this.row.scrollWidth - this.row.clientWidth;
        const scrollable = maxScroll > 1;

        this.classList.toggle('ugc-videos--scrollable', scrollable);
        this.prev.disabled = this.row.scrollLeft <= 1;
        this.next.disabled = this.row.scrollLeft >= maxScroll - 1;
      }

      onClick(event) {
        const button = event.target.closest('.ugc-videos__mute');
        if (!button) return;

        const card = button.closest('.ugc-videos__card');
        const video = card && card.querySelector('video');
        if (!video) return;

        const shouldMute = !video.muted;

        if (!shouldMute) {
          // Unmuting this one: mute every other video in the block first.
          this.querySelectorAll('video').forEach((other) => {
            if (other !== video) {
              other.muted = true;
              const otherBtn = other
                .closest('.ugc-videos__card')
                .querySelector('.ugc-videos__mute');
              if (otherBtn) otherBtn.setAttribute('aria-pressed', 'true');
            }
          });
        }

        video.muted = shouldMute;
        button.setAttribute('aria-pressed', String(shouldMute));

        // A muted autoplay video may need a nudge once sound is enabled.
        if (!shouldMute && video.paused) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        }
      }
    }
  );
}
